import { render, staticRenderFns } from "./permittings-table.vue?vue&type=template&id=0b19a2b0&scoped=true"
import script from "./permittings-table.vue?vue&type=script&lang=js"
export * from "./permittings-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b19a2b0",
  null
  
)

export default component.exports